import cloneDeep from 'lodash/fp/cloneDeep';
import leadService from '../service/leadService';
import log from '../service/log';
import variants from '@/utils/enums/alertVariants';
import i18n from '@/i18n';

const initialState = {
  mode: 'include',
  ids: [],
};

const getters = {
  isLeadSelected: state => id => state.mode === 'exclude' ? !state.ids.includes(id) : state.ids.includes(id),
};

const actions = {
  selectAll({ commit }) {
    commit('SET_MODE', 'exclude');
    commit('SET_IDS', []);
  },
  clearSelection({ commit }) {
    commit('RESET');
  },
  toggleId({ commit, state }, id) {
    const newIds = state.ids.includes(id) ? state.ids.filter(existing => existing !== id) : [...state.ids, id];
    commit('SET_IDS', newIds);
  },
  togglePageIds({ commit, state }, { ids, checked }) {
    const idSet = new Set(ids);
    const shouldAdd = state.mode === 'exclude' ? !checked : checked;
    const newIds = shouldAdd ? Array.from(new Set([...state.ids, ...ids])) : state.ids.filter(id => !idSet.has(id));
    commit('SET_IDS', newIds);
  },
  async softDeleteSelectedLeads({ commit, state }, { filters, selectedCount }) {
    try {
      const payload = { mode: state.mode, leadIds: state.ids };
      if (state.mode === 'exclude') {
        payload.filters = filters;
      }
      await leadService.softDeleteLeads(payload);
      // Clear cache to ensure no stale data in any filter combination
      leadService.clearLeadsCache();
      commit(
        'SET_MESSAGE',
        {
          variant: variants.SUCCESS,
          message: {
            msg1:
              selectedCount === 1
                ? i18n.global.t('leadDetails.deleteLeadSuccess')
                : i18n.global.t('leadsExportPage.selection.deleteSuccessMessage', { count: selectedCount }),
            msgHasLink: false,
          },
        },
        { root: true }
      );
      commit('RESET');
      return true;
    } catch (e) {
      commit(
        'SET_MESSAGE',
        {
          variant: variants.DANGER,
          message: { msg1: i18n.global.t('alerts.generalError'), msgHasLink: false },
        },
        { root: true }
      );
      log(e);
      return false;
    }
  },
};

const mutations = {
  SET_MODE(state, mode) {
    state.mode = mode;
  },
  SET_IDS(state, ids) {
    state.ids = ids;
  },
  RESET(state) {
    state.mode = 'include';
    state.ids = [];
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
};
